module.exports = __webpack_public_path__ + "img/saibamais.a802779e.jpg";